<template>
  <v-dialog
    v-model="formatoProgramacionDialog"
    width="480"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        color="secondary"
        rounded
        v-bind="attrs"
        v-on="on"
      >
        Descargar reporte <v-icon class="ml-4">
          mdi-download
        </v-icon>
      </v-btn>
    </template>
    <v-card
      color="primary"
      class="rounded-sm"
    >
      <v-card-title class="justify-center font-weight-bold">
        Descargar reporte semanal
      </v-card-title>
      <v-card-text align="center">
        <v-date-picker
          v-model="selectedFecha"
          no-title
          full-width
          color="secondary"
          :allowed-dates="allowedDates"
        />
        <div
          v-if="selectedFecha"
          class="text-subtitle-1 font-weight-bold"
        >
          Semana: {{ semana }} ({{ diaInicio }} al {{ diaFin }})
        </div>
      </v-card-text>
      <v-card-actions
        class="justify-center"
        align="center"
      >
        <v-btn
          rounded
          color="secondary"
          :disabled="!selectedFecha || loading"
          :loading="loading"
          @click="exportExcel"
        >
          Descargar reporte <v-icon>mdi-download</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from 'axios';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { publicPath } from '../../../vue.config';

const ExcelJS = require('exceljs');

let buffer = null;
const workbook = new ExcelJS.Workbook();
let worksheet = null;
let cell = null;
const initialRow = 7;

export default {
  data() {
    return {
      formatoProgramacionDialog: false,
      selectedFecha: null,
      allowedDates: (val) => new Date(val).getDay() === 0,
      loading: false,
    };
  },

  computed: {
    ...mapGetters('programacionEvaluacion', {
      programaciones: 'getProgramacionesEvaluaciones',
    }),

    semana() {
      return this.selectedFecha ? moment(this.selectedFecha).week() : '';
    },

    diaInicio() {
      return this.selectedFecha ? moment(this.selectedFecha).format('DD/MM/YYYY') : '';
    },

    diaFin() {
      return this.selectedFecha ? moment(this.selectedFecha).add(4, 'days').format('DD/MM/YYYY') : '';
    },

    filteredProgramaciones() {
      if (this.selectedFecha) {
        return this.programaciones.filter(
          (programacion) => moment(programacion.fechaEvaluacionMedica)
            .week() === this.semana && programacion,
        );
      } return [];
    },
  },

  methods: {
    async exportExcel() {
      await axios(`${publicPath}programacion.xlsx`, { responseType: 'arraybuffer' })
        .catch(() => {
          /* error in getting data */
        })
        .then(async (res) => res.data)
        .catch(() => {
          /* error in parsing */
        })
        .then(async (data) => {
          await workbook.xlsx.load(data);

          worksheet = workbook.getWorksheet(1);

          cell = worksheet.getCell('E3');
          cell.value = `PROGRAMACIÓN DE EVALUACIONES DE CONTROL DE CONFIANZA SEMANA ${
            this.semana
          } DEL ${
            moment(this.diaInicio, 'DD/MM/YYYY').format('DD')
          } AL ${
            moment(this.diaFin, 'DD/MM/YYYY').format('DD')
          } DE ${
            moment(this.diaInicio, 'DD/MM/YYYY').format('MMMM').toUpperCase()
          } DEL ${
            moment(this.diaInicio, 'DD/MM/YYYY').format('YYYY')}`;

          this.filteredProgramaciones.forEach((programacion, index) => {
            cell = worksheet.getCell(`C${initialRow + index}`);
            cell.value = index + 1;

            cell = worksheet.getCell(`D${initialRow + index}`);
            cell.value = this.getFullName(programacion.Expediente.Personal);

            cell = worksheet.getCell(`E${initialRow + index}`);
            cell.value = programacion.Expediente.Personal.rfc;

            cell = worksheet.getCell(`F${initialRow + index}`);
            cell.value = programacion.Expediente.Personal.unidadAnalisisTactico;

            cell = worksheet.getCell(`G${initialRow + index}`);
            cell.value = programacion.Expediente.Personal.unidadOperaciones;

            if (programacion.CatMotivoEvaluacion) {
              cell = worksheet.getCell(`H${initialRow + index}`);
              cell.value = programacion.CatMotivoEvaluacion.title;
            }

            cell = worksheet.getCell(`I${initialRow + index}`);
            cell.value = moment(programacion.fechaEvaluacionMedica).format('DD-MMM-YYYY');

            cell = worksheet.getCell(`J${initialRow + index}`);
            cell.value = moment(programacion.fechaEvaluacionMedica).format('hh:mm a');

            cell = worksheet.getCell(`K${initialRow + index}`);
            cell.value = moment(programacion.fechaEvaluacionMedica).format('DD-MMM-YYYY');

            cell = worksheet.getCell(`L${initialRow + index}`);
            cell.value = moment(programacion.fechaEvaluacionPsicologica).format('DD-MMM-YYYY');

            cell = worksheet.getCell(`M${initialRow + index}`);
            cell.value = moment(programacion.fechaEvaluacionPsicologica).format('hh:mm a');

            cell = worksheet.getCell(`N${initialRow + index}`);
            cell.value = moment(programacion.fechaEntrevistaIse).format('DD-MMM-YYYY');

            cell = worksheet.getCell(`O${initialRow + index}`);
            cell.value = moment(programacion.fechaEntrevistaIse).format('hh:mm a');

            cell = worksheet.getCell(`P${initialRow + index}`);
            cell.value = moment(programacion.fechaEvaluacionPoligrafica).format('DD-MMM-YYYY');

            cell = worksheet.getCell(`Q${initialRow + index}`);
            cell.value = moment(programacion.fechaEvaluacionPoligrafica).format('hh:mm a');
          });

          worksheet.removeConditionalFormatting();
          buffer = await workbook.xlsx.writeBuffer();

          const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          saveAs(blob, 'programacion.xlsx');
        });
    },
  },
};
</script>
